import { subtitleProblem } from 'lib/offer/subtitle'

// Wersja silnikowa do nazwy ogłoszenia (tytuł karty, H1, pasek, JSON-LD, e-maile); z niedozwoloną treścią — ''.
export const shortTrimFor = ({ tracking }) => {
    const { trim } = tracking || {}
    const title = String(trim?.title || '').trim()
    return title && !subtitleProblem(title) ? title : ''
}
